import { Navigate, Route, generatePath } from "react-router-dom";
import React from "react";
import { useUserFeature } from "hooks/useUserFeature";

export default function RedirectRoutes() {
  const { isCarrier } = useUserFeature();
  const loadUrl = isCarrier ? "/loads/search/:loadId" : "/loads/post/:loadId";

  return (
    <>
      <Route
        path="/haul-pay/getpaid/history/:fundingRequestId"
        element={
          <Navigate
            to={generatePath("/haulpay/carrier/manage-pay/payment-details/:fundingRequestId", {
              fundingRequestId: window.location.pathname.split("/")[4] || ""
            })}
          />
        }
      />
      <Route path="/haul-pay/getpaid/request" element={<Navigate to="/haulpay/request-pay" />} />
      <Route
        path="/load/:loadId*"
        element={
          <Navigate
            to={generatePath(loadUrl, {
              loadId: window.location.pathname.split("/")[2] || ""
            })}
          />
        }
      />
      <Route path="/settings/billing/subscription" element={<Navigate to="/settings/billing" />} />
      <Route
        path="/truck/:truckId*"
        element={
          <Navigate
            to={generatePath("/trucks/search/:truckId", {
              truckId: window.location.pathname.split("/")[2] || ""
            })}
          />
        }
      />
      <Route path="/loadsearch" element={<Navigate to="/loads/search" />} />
    </>
  );
}
